module.exports = __webpack_public_path__ + "static/media/karta-techniczna-q-led_pl.35bee2e8.pdf";